module.exports = __webpack_public_path__ + "img/material2.3a64d992.jpg";